export default __webpack_public_path__ + "static/media/purple-blur.d777d686.png";